var _style, _rect, _circle, _circle2, _circle3, _circle4, _circle5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDie(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-5 -5 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlLang: "en",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .die {\n      stroke: none;\n      fill: #624a2e;\n    }\n    .pip {\n      stroke: none;\n      fill: #f2f6fc;\n    }\n  ")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "die",
    x: -5,
    y: -5,
    width: 10,
    height: 10,
    rx: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "pip",
    cx: 0,
    cy: 0,
    r: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "pip",
    cx: -2.5,
    cy: -2.5,
    r: 1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "pip",
    cx: 2.5,
    cy: 2.5,
    r: 1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "pip",
    cx: -2.5,
    cy: 2.5,
    r: 1
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "pip",
    cx: 2.5,
    cy: -2.5,
    r: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDie);
export default __webpack_public_path__ + "static/media/die.8b492bcc602f2e2c900a6891bca58d93.svg";
export { ForwardRef as ReactComponent };